import {
  BooleanField,
  BooleanInput,
  Datagrid,
  DateField,
  DeleteWithConfirmButton,
  EditButton,
  Create as RACreate,
  Edit as RAEdit,
  Filter as RAFilter,
  List as RAList,
  SimpleForm,
  TextField,
  TextInput,
  required,
} from 'react-admin';

import CustomPagination from '../../CustomPagination';
import { useTranslate } from '../../locales';

/**
 * E-mail domains that may never register (BlockedEmailDomain). Registration refuses
 * an address whose domain, or any parent domain, has an active row here.
 *
 * The domain is normalized by the API on every write (lower-case, punycode, no "@"):
 * admins may paste "FREE-EVERYTHING.COM" or "@free-everything.com" and get
 * "free-everything.com". Nothing is normalized in this UI on purpose.
 */

const DomainForm = () => {
  const translate = useTranslate();
  return (
    <SimpleForm>
      <TextInput
        source="domain"
        label={translate('blockedEmailDomains.domain')}
        helperText={translate('blockedEmailDomains.domainHelp')}
        validate={required()}
        fullWidth
      />
      <TextInput
        source="reason"
        label={translate('blockedEmailDomains.reason')}
        helperText={translate('blockedEmailDomains.reasonHelp')}
        multiline
        fullWidth
      />
      <BooleanInput
        source="isActive"
        label={translate('blockedEmailDomains.isActive')}
        defaultValue={true}
      />
    </SimpleForm>
  );
};

export const Create = (props: any) => (
  <RACreate {...props} mutationMode="pessimistic" redirect="list">
    <DomainForm />
  </RACreate>
);

export const Edit = (props: any) => (
  <RAEdit {...props} mutationMode="pessimistic" redirect="list">
    <DomainForm />
  </RAEdit>
);

const Filters = (props: any) => {
  const translate = useTranslate();
  return (
    <RAFilter {...props}>
      <TextInput
        source="domain"
        label={translate('blockedEmailDomains.domain')}
        alwaysOn
      />
      <BooleanInput
        source="isActive"
        label={translate('blockedEmailDomains.isActive')}
      />
    </RAFilter>
  );
};

export const List = (props: any) => {
  const translate = useTranslate();
  return (
    <RAList
      {...props}
      title={translate('blockedEmailDomains.title')}
      filters={<Filters />}
      sort={{ field: 'createdAt', order: 'DESC' }}
      perPage={50}
      pagination={<CustomPagination />}>
      <Datagrid bulkActionButtons={false}>
        <TextField
          source="domain"
          label={translate('blockedEmailDomains.domain')}
        />
        <BooleanField
          source="isActive"
          label={translate('blockedEmailDomains.isActive')}
        />
        <TextField
          source="reason"
          label={translate('blockedEmailDomains.reason')}
        />
        <DateField
          source="createdAt"
          label={translate('blockedEmailDomains.createdAt')}
          showTime
        />
        <EditButton />
        <DeleteWithConfirmButton mutationMode="pessimistic" />
      </Datagrid>
    </RAList>
  );
};
